import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Glyphicon, Nav, Navbar, NavItem, NavDropdown, MenuItem, Button } from 'react-bootstrap';
import { LinkContainer } from "react-router-bootstrap";
import Auth from './Auth/Auth';
import './NavMenu.css';
import './../common/Enums';
import Enums from './../common/Enums';

export class NavMenu extends Component {
    displayName = NavMenu.name

    constructor(props) {
        super(props);
        this.auth = new Auth();

        this.state = {
            agencyName: '',
            isAutoCallActive: false,
            isAuthenticated: false,
            isExpired: false,
            loadedData: false,

        };
    }

    populateActiveFeatures() {
        if (this.state.loadedData)
            return;

        if (!this.props.auth.isAuthenticated())
            return;

        const requestOptions = {
            method: 'GET',
            headers: { 'Authorization': `Bearer ${this.props.auth.getAccessToken()}` }
        };

        fetch(`api/AgencyService/${localStorage.getItem('agency_key')}/`, requestOptions)
            .then(response => response.json())
            .then(data => {

                this.setState({
                    loadedData: true,
                    agencyName: data.name,
                    isAutoCallActive: data.features.find(element =>
                        element.featureName === Enums.autoCallFeatureName && element.isActive),
                    isExpired: !data.isActive,
                    isLoading: false,

                    contactUsMailTo: "mailto:" + process.env.REACT_APP_CONTACT_US_EMAIL + "?subject=Support " + data.name,
                    requestMailTo: "mailto:" + process.env.REACT_APP_REQUEST_EMAIL + "?subject=" + data.name + "Request Feature/Bug"
                });
            });
    }


    render() {

        this.populateActiveFeatures();

        if (!this.props.auth.isAuthenticated())
            return null;

        if (this.state.isExpired) {
            return <Redirect to="/expired" />
        }

        return (
            <Navbar inverse fixedTop collapseOnSelect fluid>
                <Navbar.Header>
                    <Navbar.Brand>
                        <Link to='/applicantList'>{this.state.agencyName}</Link>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                </Navbar.Header>
                <Navbar.Collapse>
                    {this.props.auth.isAuthenticated() &&
                        <Nav>
                            <LinkContainer to={'/applicantList'}>
                                <NavItem>
                                    <Glyphicon glyph='user' /> Applicants
                                </NavItem>
                            </LinkContainer>

                            <LinkContainer to={'/cases'}>
                                <NavItem>
                                    <Glyphicon glyph='th' /> Case Tracker
                                </NavItem>
                            </LinkContainer>
                            {this.state.isAutoCallActive &&
                                <LinkContainer to={'/autoCallDashboard'}>
                                    <NavItem>
                                        <Glyphicon glyph='earphone' /> Court Dates
                                    </NavItem>
                                </LinkContainer>
                            }
                            <LinkContainer to={'/agency'}>
                                <NavItem>
                                    <Glyphicon glyph='file' /> Agency Information
                                </NavItem>
                            </LinkContainer>
                            <NavDropdown title="Need Help?" id="basic-nav-dropdown">
                                <MenuItem href={process.env.REACT_APP_DOCUMENTATION_LINK} target="_blank">Documentation<Glyphicon glyph='new-window' /></MenuItem>
                                <MenuItem to={'/resources'} href={'/resources'} >More Resources</MenuItem>
                                <MenuItem divider />
                                <MenuItem href={process.env.REACT_APP_RELEASE_NOTES_LINK} target="_blank">Release notes <Glyphicon glyph='new-window' /></MenuItem>
                                <MenuItem href={this.state.contactUsMailTo}>Contact Us <Glyphicon glyph='new-window' /></MenuItem>
                                <MenuItem href={this.state.requestMailTo}>Submit Request or Bug <Glyphicon glyph='new-window' /></MenuItem>
                            </NavDropdown>
                        </Nav>

                    }
                    <Nav>
                        <NavItem>
                            {this.props.auth.isAuthenticated() &&
                                (
                                    <Button type="button" block
                                        onClick={this.props.auth.logout}>
                                        <span><Glyphicon glyph='log-out' />Log out</span>
                                    </Button>
                                )
                            }
                        </NavItem>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/NavMenu.js